import React, { useContext } from 'react';
import TitleBar from '../../comonents/TitleBar';
import BtnShow from '../../comonents/Buttons';
import './index.css'

import { useNavigate } from 'react-router-dom';
import ArrowDownRight from '../../comonents/Icons/Arrow-down-right';
import ArrowUpRight from '../../comonents/Icons/Arrow-up-right';
// import { useNavigate } from 'react-router-dom';
// import Cookies from 'js-cookie'
import { Context } from '../../context/Context'
// import { EXPRESS_SERVER_URL, COOKIES_EXPIRES_TIME } from "../../config";
// import axios from '../../axios'
import copy from 'copy-to-clipboard';
import Cookies from 'js-cookie'
import MerkleTree from '../../comonents/MerkleTree';




export default function Game2DashBoardVerfy() {
    return (
        <div  >

            <TitleBar backLastPage="" lastPageName="" />

            <div style={{ paddingLeft: '1rem', paddingRight: '1rem', paddingTop: '1rem' }}>

                <div style={{ marginLeft: '1rem', paddingBottom: '1rem' }}><b>Detail of the Block Data</b></div>
                <div>Block Index: <input className='BlockIndexInput' type="number" value="" /></div>


                <div className='col-md-12'>
                    <div className='row' >
                        <div className='col-md-5 Block' style={{ background: 'rgb(205, 243, 130)' }}>
                            <div className='text-decoration-underline'><b>Data 1</b></div>
                            <div className="d-flex justify-content-between">
                                <div>Public ID:</div>
                                <div>
                                    {/* {blockDetail.datas[0].pid} */}123
                                </div>
                            </div>

                            <div className="d-flex justify-content-between">
                                <div>Customer ID:</div>
                                <div> 
                                    {/* {blockDetail.datas[0].cid} */}1234
                                    </div>

                            </div>

                            <div className="d-flex justify-content-between">

                                <div> Product Quantity:</div>
                                <div>
                                    {/* {blockDetail.datas[0].pq} */} 1231
                                </div>
                            </div>

                            <div className="d-flex justify-content-between">
                                <div>Product Name:</div>
                                <div>
                                    {/* {blockDetail.datas[0].pn} */}1231
                                </div>
                            </div>

                            <div className="d-flex justify-content-between">
                                <div>Delivery Date:</div>
                                <div>
                                    {/* {dateToStr(blockDetail.datas[0].dd)} */}1234
                                </div>
                            </div>
                        </div>
                        <div className='col-md-5 Block' style={{ background: 'rgb(247, 243, 130)' }}>
                            <div className='text-decoration-underline'><b>Data 2</b></div>
                            <div className="d-flex justify-content-between">
                                <div>Public ID:</div>
                                <div>
                                    {/* {blockDetail.datas[0].pid} */}123
                                </div>
                            </div>

                            <div className="d-flex justify-content-between">
                                <div>Customer ID:</div>
                                <div> 
                                    {/* {blockDetail.datas[0].cid} */}1234
                                    </div>

                            </div>

                            <div className="d-flex justify-content-between">

                                <div> Product Quantity:</div>
                                <div>
                                    {/* {blockDetail.datas[0].pq} */} 1231
                                </div>
                            </div>

                            <div className="d-flex justify-content-between">
                                <div>Product Name:</div>
                                <div>
                                    {/* {blockDetail.datas[0].pn} */}1231
                                </div>
                            </div>

                            <div className="d-flex justify-content-between">
                                <div>Delivery Date:</div>
                                <div>
                                    {/* {dateToStr(blockDetail.datas[0].dd)} */}1234
                                </div>
                            </div>
                        </div>
                        <div className='col-md-2' >
                        </div>
                    </div>
                    <div className='row' >
                        <div className='col-md-5 Block' style={{ background: 'rgb(247, 243, 130)' }}>
                            <div className='text-decoration-underline'><b>Data 3</b></div>
                            <div className="d-flex justify-content-between">
                                <div>Public ID:</div>
                                <div>
                                    {/* {blockDetail.datas[0].pid} */}123
                                </div>
                            </div>

                            <div className="d-flex justify-content-between">
                                <div>Customer ID:</div>
                                <div> 
                                    {/* {blockDetail.datas[0].cid} */}1234
                                    </div>

                            </div>

                            <div className="d-flex justify-content-between">

                                <div> Product Quantity:</div>
                                <div>
                                    {/* {blockDetail.datas[0].pq} */} 1231
                                </div>
                            </div>

                            <div className="d-flex justify-content-between">
                                <div>Product Name:</div>
                                <div>
                                    {/* {blockDetail.datas[0].pn} */}1231
                                </div>
                            </div>

                            <div className="d-flex justify-content-between">
                                <div>Delivery Date:</div>
                                <div>
                                    {/* {dateToStr(blockDetail.datas[0].dd)} */}1234
                                </div>
                            </div>
                        </div>
                        <div className='col-md-5 Block' style={{ background: 'rgb(247, 243, 130)' }}>
                            <div className='text-decoration-underline'><b>Data 3</b></div>
                            <div className="d-flex justify-content-between">
                                <div>Public ID:</div>
                                <div>
                                    {/* {blockDetail.datas[0].pid} */}123
                                </div>
                            </div>

                            <div className="d-flex justify-content-between">
                                <div>Customer ID:</div>
                                <div> 
                                    {/* {blockDetail.datas[0].cid} */}1234
                                    </div>

                            </div>

                            <div className="d-flex justify-content-between">

                                <div> Product Quantity:</div>
                                <div>
                                    {/* {blockDetail.datas[0].pq} */} 1231
                                </div>
                            </div>

                            <div className="d-flex justify-content-between">
                                <div>Product Name:</div>
                                <div>
                                    {/* {blockDetail.datas[0].pn} */}1231
                                </div>
                            </div>

                            <div className="d-flex justify-content-between">
                                <div>Delivery Date:</div>
                                <div>
                                    {/* {dateToStr(blockDetail.datas[0].dd)} */}1234
                                </div>
                            </div>
                        </div>
                        <div className='col-md-2' >
                        </div>
                    </div>
                </div>

                <div className='row '>

                    <MerkleTree />


                    {/* <div className="col-md-5">
                        <div className="row">
                            <div className="col-md-9 BlockListItem">
                                <div className='text-decoration-underline fw-bold'>Hash 1</div>
                                Pre. Hash: 21<br />
                                Hash: <br />
                                Nonce: xx<br />
                            </div>

                            <div className='col-2 ' style={{ paddingTop: 30 }}>
                                <ArrowDownRight />
                            </div>
                        </div>
                        <div className="row ">
                            <div className="col-9 BlockListItem">
                                <div className='text-decoration-underline fw-bold'>Hash 2</div>
                                Pre. Hash: <br />
                                Hash: <br />
                                Nonce: xx<br />
                            </div>

                            <div className='col-2'  >
                                <ArrowUpRight />
                            </div>
                        </div>
                        <div className="row ">
                            <div className="col-9 BlockListItem">
                                <div className='text-decoration-underline fw-bold'>Hash 3</div>
                                Pre. Hash: 21<br />
                                Hash: <br />
                                Nonce:xx <br />
                            </div>

                            <div className='col-2' style={{ paddingTop: 30 }} >
                                <ArrowDownRight />
                            </div>
                        </div>
                        <div className="row ">
                            <div className="col-9 BlockListItem">
                                <div className='text-decoration-underline fw-bold'>Hash 4</div>
                                Pre. Hash: 21<br />
                                Hash: <br />
                                Nonce:xx <br />
                            </div>

                            <div className='col-2 ' >
                                <ArrowUpRight />
                            </div>
                        </div>

                    </div>

                    <div className="col-md-3  ">
                        <div className="row">
                            <div className="col-md-12 " style={{ width: 100, height: 70 }}>

                            </div>

                        </div>
                        <div className="row">
                            <div className="col-md-12  BlockListItem" >
                                <div className='text-decoration-underline fw-bold'>Hash 12</div>

                                Hash: <br />
                                Nonce: <input className='hashinputbtn' value="" /><br />
                            </div>

                        </div>
                        <div className="row">
                            <div className="col-md-12  " style={{ width: 100, height: 100 }}>

                            </div>

                        </div>
                        <div className="row">
                            <div className="col-md-12  BlockListItem">
                                <div className='text-decoration-underline fw-bold'>Hash 34</div>

                                Hash: <br />
                                Nonce: <input className='hashinputbtn' value="" /><br />
                            </div>

                        </div>




                    </div>
                    <div className="col-md-1 ">
                        <div className="row">
                            <div className="col-md-12 " style={{ width: 100, height: 100 }}>

                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12 "  >
                                <ArrowDownRight />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-12 " style={{ width: 100, height: 100 }}>

                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12 " >
                                <ArrowUpRight />
                            </div>
                        </div>
                    </div>


                    <div className="col-md-3 ">
                        <div className="col-md-12 " style={{ width: 100, height: 130 }} >

                        </div>
                        <div className="row">
                            <div className="col-md-12 BlockListItem" >
                                <div className='text-decoration-underline fw-bold'>Hash 123</div>

                                Hash: <br />
                                Nonce:  <input className='hashinputbtn' value="" /><br />
                            </div>

                        </div>
                        <div className="col-md-12 " style={{ width: 100, height: 100 }}>

                        </div>
                    </div> */}
                </div>

            </div>
            <div className='Btns_Back'>
                <input type="button" className='Btn_Back' value='Back'></input>
            </div>
            <br />


        </div>

    )
}